  <template>
  <v-list-item :disabled="!canAccessZero" :active-class="color" :class="[{ mini: mini }, 'cm-hightlight-option']" @click="openZero">
    <v-list-item-action class="dashboard-icon overwrite-margin">
      <v-img
        class="zero-icon"
        src="@/assets/img/zero.png"
      />
    </v-list-item-action>
    <v-list-item-title>Zero</v-list-item-title>
  </v-list-item>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: 'ZeroLink',
  computed: {
    ...mapState([
      "color", 
      "mini", 
      "serviceList"
    ]),
    canAccessZero() {
      return this.serviceList.includes('zero')
    }
  },
  methods: {
    openZero () {
      location.replace(location.protocol + "//" + process.env.VUE_APP_zero_domain)
    }
  }
}
</script>

<style lang="scss">
.dashboard-icon {
  margin-right: 20px;
  margin-left: 1px;
}
.zero-icon {
  width: 15px;
}
</style>